import styles from "./chatProgressBar.module.scss";
import React from "react";

export default function ChatFileComplete() {
  return (
    <>
      <div className={styles.progressComplete}>
        <div className={styles.progressbar}  style={{width:'100%'}}>
          <span>Processing uploaded file… Complete!</span></div>
      </div>

    </>
  );
};